<div class="component-container base-data-container">
  <form [formGroup]="baseDataFG" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
    <div class="form-background">
      <div
        *ngIf="!isReadOnly && !isHeatingForm && baseDataLength > 1"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 right-aligned">
        <div (click)="removeElement()" class="pi pi-trash pointer-cursor"></div>
      </div>
      <div class="ui-g form-rows">
        <div *ngIf="baseDataFG.get('facilityType')" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required" for="base-data-facility-type">
            {{ 'facilities-data.form-fields.facility-type' | translate }}
          </label>
          <p-dropdown
            (onChange)="onFacilityTypeChange($event)"
            [options]="facilityTypes"
            [readonly]="isReadOnly"
            formControlName="facilityType"
            id="base-data-facility-type"
            placeholder="-Select-">
            <ng-template let-item pTemplate="selectedItem">
              <span class="drop-item-label">{{ 'lookup.' + facilityTypeKey + '.options.' + item['value'] + '.name' | translate }}</span>
            </ng-template>
            <ng-template let-option pTemplate="item">
              <div class="drop-item">
                <span class="drop-item-label">{{ 'lookup.' + facilityTypeKey + '.options.' + option['value'] + '.name' | translate }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <div *ngIf="baseDataFG.get('totalHeatOutput')" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label class="ui-g-5 field-label text-right-align required" for="base-data-total-heat-output">
            {{ 'facilities-data.form-fields.total-heat-output' | translate }}
          </label>
          <input
            readonly
            class="ui-input pInputText"
            formControlName="totalHeatOutput"
            id="base-data-total-heat-output"
            maxlength="20"
            pInputText
            size="30"
            type="text" />
        </div>
        <div
          *ngIf="selectedFacilityType === 'commercial' && baseDataFG.get('registration')"
          class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label class="ui-g-5 field-label text-right-align required" for="base-data-registration">
            {{ 'facilities-data.form-fields.registration' | translate }}
          </label>
          <input
            [readonly]="isReadOnly"
            class="ui-input pInputText"
            formControlName="registration"
            id="base-data-registration"
            maxlength="20"
            pInputText
            size="30"
            type="text" />
        </div>
        <div
          *ngIf="baseDataFG.get('oldPowerGridConnection')"
          class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label class="ui-g-7 field-label text-right-align required" for="old-power-grid-connection">
            {{ 'facilities-data.form-fields.old-power-grid-connection' | translate }}
          </label>
          <input
            [appNumber]="true"
            [readonly]="isReadOnly"
            class="ui-g-4 ui-input pInputText small-width"
            formControlName="oldPowerGridConnection"
            id="old-power-grid-connection"
            pInputText
            size="30"
            type="text" />
          <span class="ui-g-1">kW</span>
        </div>
        <ng-container *ngIf="baseDataFG.get('measuringPointCheckbox')">
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
            <p-checkbox
              appEnterClick
              [readonly]="isReadOnly"
              binary="true"
              class="checkbox-field"
              formControlName="measuringPointCheckbox"
              id="base-data-measuring-point-checkbox"
              label="{{ 'facilities-data.form-fields.measuring-point-checkbox' | translate }}"></p-checkbox>
          </div>
          <div
            *ngIf="baseDataFG.get('measuringPointCheckbox').value"
            class="ui-g-offset-6 ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
            <span>{{ 'facilities-data.measuring-text' | translate }}</span>
          </div>
        </ng-container>

        <div
          *ngIf="baseDataFG.get('simultaneouslyRequiredTotalPowerAfterInstallationChange')"
          class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label class="ui-g-8 field-label text-right-align required" for="old-power-grid-connection">
            {{ 'facilities-data.form-fields.simultaneously-required-total-power-after-installation-change' | translate }}
          </label>
          <input
            [appNumber]="true"
            [readonly]="isReadOnly"
            class="ui-g-4 ui-input pInputText small-width"
            formControlName="simultaneouslyRequiredTotalPowerAfterInstallationChange"
            id="simultaneously-required-total-power-after-installation-change"
            pInputText
            size="30"
            type="text" />
        </div>
      </div>
      <div *ngIf="baseDataFG.get('facilityType')?.value === 'other'" class="ui-g form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align" for="base-data-other-type"></label>
          <input
            [readonly]="isReadOnly"
            class="ui-input pInputText"
            formControlName="otherType"
            id="base-data-other-type"
            pInputText
            type="text" />
        </div>
      </div>
      <div class="ui-g form-rows">
        <div
          *ngIf="selectedFacilityType === 'commercial' && !showGasUsageForComercial"
          class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label class="ui-g-5 field-label text-right-align" for="base-data-sector">
            {{ 'facilities-data.form-fields.sector' | translate }}
          </label>
          <input
            [readonly]="isReadOnly"
            class="ui-input pInputText"
            formControlName="sector"
            id="base-data-sector"
            maxlength="20"
            pInputText
            size="30"
            type="text" />
        </div>

        <div
          *ngIf="selectedFacilityType === 'commercial' && showGasUsageForComercial"
          class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding checkbox-bottom-padding">
          <label class="ui-g-5 field-label text-right-align" for="gas-usage-for">{{ 'facilities-data.form-fields.use' | translate }}</label>
          <p-dropdown
            [options]="gasUsageForOptions"
            [readonly]="isReadOnly"
            formControlName="gasUsageFor"
            id="gas-usage-for"
            placeholder="-Select-">
            <ng-template let-item pTemplate="selectedItem">
              <span class="drop-item-label">{{ 'lookup.' + gasUsageForKey + '.options.' + item['value'] + '.name' | translate }}</span>
            </ng-template>
            <ng-template let-option pTemplate="item">
              <div class="drop-item">
                <span class="drop-item-label">{{ 'lookup.' + gasUsageForKey + '.options.' + option['value'] + '.name' | translate }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>

        <div
          *ngIf="selectedFacilityType === 'generation_facility' && showFacilityAdditionalData"
          class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label class="ui-g-5"></label>
          <p-checkbox
            appEnterClick
            [readonly]="isReadOnly"
            binary="true"
            class="ui-g-4 internal-consumption-field checkbox-field"
            formControlName="internalConsumptionCheckbox"
            id="base-data-internal-consumption-check"
            label="{{ 'facilities-data.form-fields.internal-consumption-checkbox' | translate }}"></p-checkbox>
          <p-checkbox
            appEnterClick
            [readonly]="isReadOnly"
            binary="true"
            class="checkbox-field"
            formControlName="storageSystemCheckbox"
            id="base-data-storage-system-check"
            label="{{ 'facilities-data.form-fields.storage-system-checkbox' | translate }}"></p-checkbox>
        </div>
        <div
          *ngIf="selectedFacilityType !== 'commercial' && showFacilityAdditionalData"
          class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding checkbox-bottom-padding">
          <label
            [class.required]="baseDataFG.get('placeOfMeter')?.validator"
            class="ui-g-5 field-label text-right-align"
            for="base-data-meter-place">
            {{ 'facilities-data.form-fields.place-of-meter' | translate }}
          </label>
          <p-dropdown
            (onChange)="selectPlaceOfMeter($event)"
            [options]="placesOfMeter"
            [readonly]="isReadOnly"
            formControlName="placeOfMeter"
            id="base-data-meter-place"
            placeholder="-Select-">
            <ng-template let-item pTemplate="selectedItem">
              <span class="drop-item-label">{{ 'lookup.' + placeOfMeterKey + '.options.' + item['value'] + '.name' | translate }}</span>
            </ng-template>
            <ng-template let-option pTemplate="item">
              <div class="drop-item">
                <span class="drop-item-label">{{ 'lookup.' + placeOfMeterKey + '.options.' + option['value'] + '.name' | translate }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>

        <div
          class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows"
          *ngIf="baseDataFG.get('isPowerConnectionForRemoteMeterReadingAvailable')">
          <label class="ui-g-5 field-label text-right-align required margin-right-align">
            {{ 'facilities-data.form-fields.power-connection-remote-meter-label' | translate }}
          </label>
          <p-radioButton
            name="isPowerConnectionForRemoteMeterReadingAvailable"
            formControlName="isPowerConnectionForRemoteMeterReadingAvailable"
            value="1"
            label="{{ 'yes-button-label' | translate }}"
            class="margin-right-align"></p-radioButton>
          <p-radioButton
            name="isPowerConnectionForRemoteMeterReadingAvailable"
            formControlName="isPowerConnectionForRemoteMeterReadingAvailable"
            value="0"
            label="{{ 'no-button-label' | translate }}"></p-radioButton>
        </div>

        <div
          *ngIf="baseDataFG.get('newPowerGridConnection')"
          class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label class="ui-g-7 field-label text-right-align required" for="new-power-grid-connection">
            {{ 'facilities-data.form-fields.new-power-grid-connection' | translate }}
          </label>
          <input
            [appNumber]="true"
            [readonly]="isReadOnly"
            class="ui-g-4 ui-input pInputText small-width"
            formControlName="newPowerGridConnection"
            id="new-power-grid-connection"
            pInputText
            size="30"
            type="text" />
          <span class="ui-g-1">kW</span>
        </div>
      </div>
      <div *ngIf="selectedFacilityType === 'commercial'" class="ui-g form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding checkbox-bottom-padding">
          <label
            [class.required]="baseDataFG.get('placeOfMeter')?.validator"
            class="ui-g-5 field-label text-right-align"
            for="base-data-meter-place-commercial">
            {{ 'facilities-data.form-fields.place-of-meter' | translate }}
          </label>
          <p-dropdown
            (onChange)="selectPlaceOfMeter($event)"
            [options]="placesOfMeter"
            [readonly]="isReadOnly"
            formControlName="placeOfMeter"
            id="base-data-meter-place-commercial"
            placeholder="-Select-">
            <ng-template let-item pTemplate="selectedItem">
              <span class="drop-item-label">{{ 'lookup.' + placeOfMeterKey + '.options.' + item['value'] + '.name' | translate }}</span>
            </ng-template>
            <ng-template let-option pTemplate="item">
              <div class="drop-item">
                <span class="drop-item-label">{{ 'lookup.' + placeOfMeterKey + '.options.' + option['value'] + '.name' | translate }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>
      <div *ngIf="baseDataFG.get('placeOfMeter').value === 'other'" class="ui-g form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label class="ui-g-5 field-label text-right-align" for="base-data-other-location">
            {{ environmentService.showOtherLocationLabel ? ('facilities-data.form-fields.other-location' | translate) : '' }}
          </label>
          <input
            [readonly]="isReadOnly"
            class="ui-input pInputText"
            formControlName="otherLocation"
            id="base-data-other-location"
            pInputText
            type="text" />
        </div>
      </div>

      <!-- Meter location designation should be displayed for Meter mounting & power only -->
      <div *ngIf="showMeterLocationDesignation" class="ui-g form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align" for="meter-location-designation">
            {{ 'facilities-data.form-fields.meter-location-designation' | translate }}
          </label>
          <input
            [readonly]="isReadOnly"
            class="ui-g-4 ui-input pInputText"
            formControlName="meterLocationDesignation"
            id="meter-location-designation"
            pInputText
            type="text"
            maxlength="200" />
        </div>
      </div>
      <!-- reason for request should be displayed for Meter mounting and New installation for all commodities -->
      <div *ngIf="showMeterMountingAndChangeInstallationAdditionalData" class="ui-g form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required" for="reason-for-request">
            {{ 'facilities-data.form-fields.reason-for-request' | translate }}
          </label>
          <input
            [readonly]="isReadOnly"
            class="ui-g-4 ui-input pInputText"
            formControlName="reasonForRequest"
            id="reason-for-request"
            pInputText
            type="text"
            maxlength="1000" />
        </div>
      </div>
      <div *ngIf="showMeasuringConceptAndMeterType" class="ui-g form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required" for="base-data-measuring-concept">
            {{ 'technical-data.measure-concept' | translate }}
          </label>
          <p-dropdown
            [options]="measuringConcepts"
            [readonly]="isReadOnly"
            formControlName="measuringConcept"
            id="base-data-measuring-concept"
            placeholder="-Select-">
            <ng-template let-item pTemplate="selectedItem">
              <span class="drop-item-label">{{ 'lookup.' + measuringConceptKey + '.options.' + item['value'] + '.name' | translate }}</span>
            </ng-template>
            <ng-template let-option pTemplate="item">
              <div class="drop-item">
                <span class="drop-item-label">
                  {{ 'lookup.' + measuringConceptKey + '.options.' + option['value'] + '.name' | translate }}
                </span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required" for="base-data-meter-type">
            {{ 'basic-profile.jurisdiction.meter-data.meter_type' | translate }}
          </label>
          <p-dropdown
            [options]="typeOfMeters"
            [readonly]="isReadOnly"
            formControlName="typeOfMeter"
            id="base-data-meter-type"
            placeholder="-Select-">
            <ng-template let-item pTemplate="selectedItem">
              <span class="drop-item-label">{{ 'lookup.' + typeOfMetertKey + '.options.' + item['value'] + '.name' | translate }}</span>
            </ng-template>
            <ng-template let-option pTemplate="item">
              <div class="drop-item">
                <span class="drop-item-label">
                  {{ 'lookup.' + typeOfMetertKey + '.options.' + option['value'] + '.name' | translate }}
                </span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>
      <!-- heated living space should be displayed for Meter mounting and Change Installation for distring heating commodity only -->
      <div *ngIf="showMeterMountingAndChangeInstallationAdditionalData && isHeatingForm" class="ui-g form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align" for="heated-living-space">
            {{ 'facilities-data.form-fields.heated-living-space' | translate }}
          </label>
          <input
            [readonly]="isReadOnly"
            class="ui-g-4 ui-input pInputText"
            formControlName="heatedLivingSpace"
            id="heated-living-space"
            pInputText
            appFloatNumber="2" />
          <span class="unit-margin">{{ allUnits.area }}</span>
        </div>
      </div>
      <!-- volume flow qmax should be displayed for Meter mounting and Change Installation for distring heating commodity only -->
      <div *ngIf="showMeterMountingAndChangeInstallationAdditionalData && isHeatingForm" class="ui-g form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align" for="volume-flow-qmax">
            {{ 'facilities-data.form-fields.volume-flow-qmax' | translate }}
          </label>
          <input
            [readonly]="isReadOnly"
            class="ui-g-4 ui-input pInputText"
            formControlName="volumeFlowQmax"
            id="volume-flow-qmax"
            pInputText
            appFloatNumber="2" />
          <span class="unit-margin">{{ allUnits.volumeFlowRate }}</span>
        </div>
      </div>
      <!-- flow temperature should be displayed for Meter mounting and Change Installation for distring heating commodity only -->
      <div *ngIf="showMeterMountingAndChangeInstallationAdditionalData && isHeatingForm" class="ui-g form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align" for="flow-temperature">
            {{ 'facilities-data.form-fields.flow-temperature' | translate }}
          </label>
          <input
            [readonly]="isReadOnly"
            class="ui-g-4 ui-input pInputText"
            formControlName="flowTemperature"
            id="flow-temperature"
            pInputText
            appFloatNumber="2" />
          <span class="unit-margin">{{ allUnits.temperature }}</span>
        </div>
      </div>
      <!-- return temperature should be displayed for Meter mounting and Change Installation for distring heating commodity only -->
      <div *ngIf="showMeterMountingAndChangeInstallationAdditionalData && isHeatingForm" class="ui-g form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align" for="return-temperature">
            {{ 'facilities-data.form-fields.return-temperature' | translate }}
          </label>
          <input
            [readonly]="isReadOnly"
            class="ui-g-4 ui-input pInputText"
            formControlName="returnTemperature"
            id="return-temperature"
            pInputText
            appFloatNumber="2" />
          <span class="unit-margin">{{ allUnits.temperature }}</span>
        </div>
      </div>
      <div *ngIf="showSpecialApplienceSection && currentFormType.index === 0">
        <ng-container *ngFor="let value of specialApplianceCount; let i = index">
          <app-special-appliance
            [displayDeleteButton]="!showDefaultDeviceSubSection || (showDefaultDeviceSubSection && specialApplianceCount.length > 1)"
            (specialApplianceSelection)="evaluateDeviceTextVisibility()"
            [isReadOnly]="isReadOnly"
            (deleteComponent)="removeChildElements($event)"
            [parentIndex]="currentIndex"
            [currentIndex]="i"
            [hideAdditionalData]="!showFacilityAdditionalData"
            [specialApplianceData]="specialApplianceData[value]"
            [currentFormType]="currentFormType"></app-special-appliance>
        </ng-container>
        <div class="ui-g-12 add-button-row" *ngIf="!isReadOnly && showData">
          <div class="empty-container"></div>
          <i (click)="addSpecialAppliance()" class="pi pi-plus plus-icon" id="base-data-add-appliance" tabindex="0" appEnterClick></i>
          <label class="ui-g-5 field-label" for="base-data-add-appliance">
            {{ 'facilities-data.form-fields.special-appliance-button' | translate }}
          </label>
        </div>
        <div *ngIf="showDeviceAreaText" class="device-area-text">{{ 'facilities-data.special-appliance-text' | translate }}</div>
      </div>
      <div *ngIf="isGasForm && showGasDeviceSection">
        <ng-container *ngFor="let value of gasDeviceCount; let i = index">
          <app-gas-device
            [isReadOnly]="isReadOnly"
            (deleteComponent)="removeChildElements($event)"
            [gasDeviceData]="gasDeviceData[value]"
            [currentIndex]="i"
            [displayDeleteButton]="gasDeviceCount.length > 1"
            [parentIndex]="currentIndex"></app-gas-device>
        </ng-container>
        <div class="ui-g-12 add-button-row" *ngIf="!isReadOnly">
          <div class="empty-container"></div>
          <i (click)="addGasDevice()" class="pi pi-plus plus-icon" id="base-data-add-gas-device" tabindex="0" appEnterClick></i>
          <label class="ui-g-5 field-label" for="base-data-add-appliance">
            {{ 'facilities-data.form-fields.gas-device-button' | translate }}
          </label>
        </div>
      </div>
      <div *ngIf="isWaterForm">
        <div class="ui-g form-rows">
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding" *ngIf="!hideWaterTapOptionsForCommercial">
            <label class="ui-g-5 field-label text-right-align" for="base-data-sumFlowRate">
              {{ 'facilities-data.form-fields.sum_flow_rate' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              formControlName="sumFlowRate"
              id="base-data-sumFlowRate"
              pInputText
              size="30"
              appFloatNumber="2"
              [readonly]="isReadOnly" />
            <span class="unit-margin">{{ allUnits.peakFlow }}</span>
          </div>
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding print-top-padding">
            <label [class.required]="isPeakFlowRateRequired" class="ui-g-5 field-label text-right-align" for="base-data-peakFlowRate">
              {{ 'facilities-data.form-fields.peak_flow_rate' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              formControlName="peakFlowRate"
              id="base-data-peakFlowRate"
              pInputText
              size="30"
              appFloatNumber="2"
              [readonly]="isReadOnly" />
            <span class="unit-margin">{{ allUnits.peakFlow }}</span>
          </div>
        </div>
        <app-water-system-components
          *ngIf="showWaterSystemComponents"
          [form]="baseDataFG"
          [isReadOnly]="isReadOnly"></app-water-system-components>
      </div>
      <div *ngIf="isWaterForm">
        <ng-container *ngFor="let value of waterDeviceCount; let i = index">
          <app-water-device
            [isReadOnly]="isReadOnly"
            (deleteComponent)="removeChildElements(i)"
            [parentIndex]="currentIndex"
            [currentIndex]="i"
            [displayDeleteButton]="!showDefaultDeviceSubSection || (showDefaultDeviceSubSection && waterDeviceCount.length > 1)"
            [waterDeviceData]="waterDeviceData[value]"></app-water-device>
        </ng-container>
        <div class="ui-g-12 add-button-row" *ngIf="!isReadOnly && !hideWaterTapOptionsForHousing">
          <div class="empty-container"></div>
          <i (click)="addWaterDevice()" class="pi pi-plus plus-icon" id="base-data-add-water-device" tabindex="0" appEnterClick></i>
          <label class="ui-g-5 field-label" for="base-data-add-appliance">
            {{ 'facilities-data.form-fields.water-device-button' | translate }}
          </label>
        </div>
      </div>

      <div *ngIf="isHeatingForm">
        <app-district-heat-device [isReadOnly]="isReadOnly" [heatingDeviceData]="heatingDeviceData"></app-district-heat-device>
      </div>
    </div>
  </form>
</div>
